export default __webpack_public_path__ + "static/media/MONT-BLANC-LIGHT.b8c45567.OTF";